import './App.css';
import Hero from './components/Hero.component/Hero';
import RocketDock from './components/RocketDock/RocketDock';
import { Route, Routes } from 'react-router-dom';
import About from './components/about/About';
import Project from './components/projects/Project';
import Contact from './components/contact/Contact';
import Error404 from "./components/Error404/Error404";
import ProjectView from './components/projects/ProjectView';
import ProjectComponent from './components/projects/ProjectComponent';

function App() {
  return (
    <div className="flex overflow-hidden items-center justify-center relative">
       <Routes>
         <Route path="/" element={ <Hero /> } />
         <Route path="/about" element={ <About /> } />
          <Route path="/projects" element={<ProjectComponent />}>
          <Route index element={<Project />} />
            <Route path=":projectId" element={<ProjectView />} />
          </Route>
         <Route path="/contactme" element={ <Contact /> } />
         <Route path="*" element={ <Error404/> }/>
      </Routes>
      <RocketDock/>
    </div>
  );
}

export default App;
